import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const QuickActions = () => {
  const quickActionItems = [
    {
      title: "Create New Design",
      description: "Start a new project with client collaboration",
      icon: "Plus",
      path: "/new-quote",
      variant: "default",
      featured: true
    },
    {
      title: "Team Management",
      description: "Manage team members and permissions",
      icon: "Users",
      path: "/team-management",
      variant: "outline"
    },
    {
      title: "Digital Vault",
      description: "Access secure file storage",
      icon: "Shield",
      path: "/digital-vault",
      variant: "outline"
    },
    {
      title: "View Feedback",
      description: "Review client responses and approvals",
      icon: "MessageSquare",
      path: "/feedback-dashboard",
      variant: "outline"
    }
  ];

  const handleSupportClick = () => {
    // Open support documentation or help center
    window.open('mailto:support@jewelthread.com?subject=Support Request', '_blank');
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-4">
        {quickActionItems?.map((action, index) => (
          <Link 
            key={index}
            to={action?.path}
            className={`block p-5 rounded-xl border-2 transition-luxury hover:elevation-2 hover:shadow-lg transform hover:-translate-y-0.5 ${
              action?.featured 
                ? 'bg-gradient-to-r from-accent/10 to-accent/20 border-accent/40 hover:bg-gradient-to-r hover:from-accent/20 hover:to-accent/30 hover:border-accent/60' :'bg-gradient-to-r from-muted/20 to-muted/30 border-border/60 hover:bg-gradient-to-r hover:from-muted/30 hover:to-muted/40 hover:border-accent/30'
            }`}
          >
            <div className="flex items-start space-x-4">
              <div className={`w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0 shadow-sm border ${
                action?.featured 
                  ? 'bg-gradient-to-br from-accent to-accent/80 text-accent-foreground border-accent/30' 
                  : 'bg-gradient-to-br from-secondary to-secondary/80 text-secondary-foreground border-secondary/30'
              }`}>
                <Icon name={action?.icon} size={24} />
              </div>
              
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-foreground mb-2 text-lg">{action?.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{action?.description}</p>
              </div>
              
              <div className="flex-shrink-0 mt-2">
                <div className="w-8 h-8 bg-muted/40 border border-muted/60 rounded-lg flex items-center justify-center">
                  <Icon name="ArrowRight" size={16} className="text-muted-foreground" />
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
      
      <div className="pt-6 border-t-2 border-border/60">
        <div className="bg-gradient-to-r from-info/10 to-info/20 border-2 border-info/30 rounded-xl p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-br from-info/20 to-info/30 border border-info/40 rounded-lg flex items-center justify-center">
                <Icon name="HelpCircle" size={20} className="text-info" />
              </div>
              <div>
                <h3 className="font-heading text-foreground mb-1">Need Help?</h3>
                <p className="text-sm text-muted-foreground">Get started with our documentation</p>
              </div>
            </div>
            <Button 
              variant="ghost" 
              size="sm" 
              iconName="ExternalLink" 
              iconPosition="right"
              onClick={handleSupportClick}
              className="hover:bg-info/10 border border-info/30 hover:border-info/50"
            >
              Support
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;